@if (deviceGroup$ | async; as deviceGroup) {
  <div class="main-container">
    <app-card class="flex-2" [loading]="(loading$ | async) ?? false">
      <div class="header">
        <button type="button" class="button icon-button" (click)="onBack()">
          <app-icon name="ic_chevron_left" />
          <span class="hidden-on-mobile">{{ "default.back" | translate }}</span>
        </button>

        <div class="actions">
          <button type="button" class="button icon-button" (click)="onEdit()">
            <app-icon name="ic_edit" />
            {{ "default.edit" | translate }}
          </button>
          <button
            type="button"
            class="button icon-button"
            (click)="onToggleFavorite(deviceGroup)"
          >
            @if (deviceGroup.isFavorite) {
              <app-icon class="color-favorite" name="ic_star_filled" />
            } @else {
              <app-icon name="ic_star" />
            }
          </button>
          <app-context-menu [menuItems]="contextMenu" />
        </div>
      </div>

      <section class="content">
        <div class="flex mb-2">
          <h2>
            {{ deviceGroup.name }}
          </h2>
          <app-tag>
            {{
              LabelConverter.getDeviceGroupStateLabel(deviceGroup.state)
                | translate
                  : (isPartiallyActive
                      ? { activeCount: activeDeviceCount, count: deviceCount }
                      : {})
            }}
          </app-tag>
        </div>
      </section>

      <section>
        <h3 class="mb-2">
          {{ "devices.devices" | translate }} ({{ deviceGroup.devices.length }})
        </h3>
        <div class="device-wrapper content grid grid-cols-2">
          @for (device of deviceList$ | async; track device.id) {
            <app-device-item-card [device]="device" />
          } @empty {
            {{ "devices.empty" | translate }}
          }
        </div>
      </section>
    </app-card>
    <app-device-rules-card
      [rules]="(ruleList$ | async) ?? []"
      (createRule)="onCreateRule()"
    />
  </div>

  <div class="detail-container">
    <app-map-with-location
      class="map-wrapper"
      [devices]="mapDeviceList$ | async"
      [groupKey]="deviceGroup.id"
    />

    <app-history
      class="flex-1"
      [history]="history"
      [loading]="historyLoading"
      [canLoadMore]="canLoadMoreHistory"
      (loadMore)="onLoadMoreHistory()"
    />
  </div>
} @else {
  <app-not-found [loading]="(loading$ | async) ?? false" />
}
